import { render, staticRenderFns } from "./articleDetails.vue?vue&type=template&id=e2a04aa2&scoped=true&"
import script from "./articleDetails.vue?vue&type=script&lang=js&"
export * from "./articleDetails.vue?vue&type=script&lang=js&"
import style0 from "./articleDetails.vue?vue&type=style&index=0&id=e2a04aa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a04aa2",
  null
  
)

export default component.exports